import React from 'react';

const PrintClassStatistics = ({ moyenneSemestre }) => {
  const formatMoyenne = (moyenne) => {
    if (moyenne === null || moyenne === undefined || moyenne === 0) return 'N/A';
    return `${moyenne.toFixed(2)}/20`;
  };

  const formatTauxReussite = (taux) => {
    if (taux === null || taux === undefined || taux === 0) return 'N/A';
    return `${taux.toFixed(1)}%`;
  };

  return (
    <div style={{ marginBottom: '8px', pageBreakInside: 'avoid' }}>
      {/* Statistiques de classe */}
      <div style={{ 
        border: '1px solid #000', 
        padding: '6px', 
        marginBottom: '4px',
        backgroundColor: '#f8f9fa',
        minHeight: '140px' // Augmenté pour équilibrer avec PrintDecisionConseil
      }}>
        <h4 style={{ 
          margin: '0 0 4px 0', 
          fontSize: '9pt', 
          fontWeight: 'bold',
          textAlign: 'center',
          borderBottom: '1px solid #000',
          paddingBottom: '2px'
        }}>
          Statistiques de classe
        </h4>
        <div style={{ fontSize: '8pt', lineHeight: '1.4' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
            <span style={{ fontWeight: '600' }}>Moyenne de classe :</span>
            <span style={{ fontWeight: 'bold' }}>{formatMoyenne(moyenneSemestre?.moyenne_classe)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
            <span style={{ fontWeight: '600' }}>Plus forte moyenne :</span>
            <span style={{ fontWeight: 'bold', color: '#059669' }}>{formatMoyenne(moyenneSemestre?.plus_forte_moyenne)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
            <span style={{ fontWeight: '600' }}>Plus faible moyenne :</span>
            <span style={{ fontWeight: 'bold', color: '#dc2626' }}>{formatMoyenne(moyenneSemestre?.plus_faible_moyenne)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
            <span style={{ fontWeight: '600' }}>Taux de réussite :</span>
            <span style={{ fontWeight: 'bold', color: '#1d4ed8' }}>{formatTauxReussite(moyenneSemestre?.taux_reussite)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintClassStatistics;
